module.exports = __webpack_public_path__ + "static/media/50000d_p.12022106.jpg";